

'use strict';
import { hasSize } from '../lib/is-mobile';



// Group elements in array by column count
const groupElemByColumn = columns => (total, current, index) => {
    if ( index % columns === 0 ) {
        total.push([]);
    }

    total[total.length-1].push(current);

    return total;
};



// Return heighest value
const getElemMaxHeight = (total, current) =>
    total < current.offsetHeight ? current.offsetHeight : total;



export default function fixProductHeight (selector, columns) {
    if (!selector) return;

    if (!columns) {
        columns = hasSize('sm') ? hasSize('xs') ? 1 : 2 : 3;
    }
    const elements = [...document.querySelectorAll(selector)];

    // Reset title height
    elements.forEach(element => element.style.height = 'initial');

    // Set element height to max in column
    elements
        .reduce(groupElemByColumn(columns), [])
        .map(elements => {
            const maxHeight = elements.reduce(getElemMaxHeight , 0);
            elements.forEach(element => element.style.height = maxHeight+'px');
        });
}
